import * as React from 'react';
import { UIText1, UIText3 } from '@cian/ui-kit';
import { clsx } from 'clsx';

import * as styles from './PromoFeatures.css';
import { IPromoProp } from '../../../../types/specialPromos/promoProp';

interface IPromoFeaturesProps {
  features: IPromoProp[];
}

export const PromoFeatures: React.FC<IPromoFeaturesProps> = ({ features }) => {
  const featuresInTwoLines = features.length > 3;

  return (
    <ul className={clsx(styles['features-list'], { [styles['two-lines']]: featuresInTwoLines })}>
      {features.map((feature, idx) => (
        <li key={idx}>
          <div className={styles['feature-title']}>
            <UIText3 color="black_60">{feature.title}</UIText3>
          </div>
          <UIText1 display="block">{feature.value}</UIText1>
        </li>
      ))}
    </ul>
  );
};
